import { useEffect, useSyncExternalStore } from "react";

const requests = new Set<symbol>();
const listeners = new Set<() => void>();
const notify = () => listeners.forEach(listener => listener());
const snapshot = () => requests.size > 0 && document.visibilityState === "visible";
const subscribe = (listener: () => void) => {
	listeners.add(listener);
	document.addEventListener("visibilitychange", listener);
	return () => {
		listeners.delete(listener);
		document.removeEventListener("visibilitychange", listener);
	};
};

export function useMapLocationDemand(): boolean {
	return useSyncExternalStore(subscribe, snapshot, () => false);
}

export function useMapLocationRequest(enabled = true): void {
	useEffect(() => {
		if (!enabled) return;
		const request = Symbol();
		requests.add(request);
		notify();
		return () => { requests.delete(request); notify(); };
	}, [enabled]);
}